/**
 * Violation Descriptions Map
 * 
 * This file contains all violation descriptions used throughout the application.
 * Using a centralized map makes it easy to update descriptions in the future.
 * 
 * Keys should match the ViolationScreenName from the ViolationMaster table.
 */

const violationDescriptions = {
  // Driving Violations
  'Over Speed': 'Driving the vehicle above the permissible speed limit.',
  'Object Hit': 'Collisions with any static objects in the environment.',
  'NPCs Hit': 'Accidental contact with non-player characters during operation.',
  'visualObstructionWrongDriving': 'Driving with impaired visibility or through visually blocked paths.',
  'forkInproperPositionDriving': 'Moving the vehicle with the forklift in an unsafe or incorrect position.',
  
  // Loading/Unloading Violations
  'loadPlacedIncorrectly': 'Situations where cargo was positioned outside the correct zone or orientation.',
  'loadsLiftedIncorrectly': 'Lifting cargo in an unstable or unsafe manner.',
  
  // Parking Violations
  'inproperParkingAttempts': 'Instances where the vehicle was not parked within the designated area or alignment.',
  
  // Operation Violations
  'performedDualAction': 'Executing two vehicle operations simultaneously in a way that violates safety or task rules.'
};

export default violationDescriptions; 